import React from "react";
import './App.css';
import {
  Navigate,
  Routes,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme.js'
import AuthContext from './providers/AuthProvider'
import CurrentClientContext from './providers/CurrentClientProvider'
import Layout from './layouts/Layout'
import MainLayout from './layouts/MainLayout'
import V3GlobalLayout from './layouts/V3GlobalLayout'
import V3SiteLayout from './layouts/V3SiteLayout'
import GlobalTip from './providers/GlobalTip'
import NotFound from './pages/NotFound'
import NotLogin from './pages/NotLogin'
import Home from './pages/Home'
import Users from './pages/admin/Users'
import UserDetail from './pages/admin/UserDetail'
import UserRoles from './pages/admin/UserRoles'
import ClientSetup from './pages/admin/ClientSetup'
import Permission from './pages/admin/Permission'
import AuthMiddleware from './components/layout/AuthMiddleware'
import ClientMiddleware from './components/layout/ClientMiddleware'
import ClientProfile from './pages/client/ClientProfile'
import ImportClass from './pages/client/ImportClass'
import ClientMasterClassSetting from './pages/client/MasterClass'
import ClientLocations from './pages/client/ClientLocations'
import ClientClasses from './pages/client/ClientClasses'
import ClientCategories from './pages/client/ClientCategories'
import UploadData from './pages/client/UploadData'
import FlightControl from './pages/flight/FlightControl'
import BasePlan from "./pages/plan/BasePlan";
import LivePlanModify from "./pages/plan/LivePlanModify";
import LivePlanModifyWeekly from "./pages/plan/LivePlanModifyWeekly";
import CopyPlan from "./pages/plan/CopyPlan";
import RetailAgent from "./pages/plan/RetailAgent";
import CopyPlanUpload from "./pages/plan/CopyPlanUpload";
import CopyPlanFileDetail from "./pages/plan/CopyPlanFileDetail";
import {ConfirmDialogProvider} from './providers/ConfirmDialog';
import ClientTags from './pages/client/ClientTags';
import ForgotPassword from "./pages/ForgotPassword";
import RestorePassword from "./pages/RestorePassword";
import ClientPosMapping from "./pages/client/ClientPosMapping";
import ClientKPI from "./pages/client/ClientKPI";
import ClientAnalytics from "./pages/client/ClientAnalytics";
import IndieAi from "./pages/client/IndieAi";
import ClientPlanPreview from "./pages/client/ClientPlanPreview";
import ClientReportLibrary from "./pages/client/ClientReportLibrary";
import PermissionMiddleware from "./components/layout/PermissionsMiddleware.js";
// import ClientSync from "./pages/admin/ClientSync";
import ClientAdd from "./pages/admin/ClientAdd.js";
import LightspeedAuthLanding from "./pages/lightspeed/LightspeedAuthLanding.js";
import DevTools from "./pages/dev-tools/DevTools.js";
import CustomCalendarManagement from "./pages/admin/CustomCalendarManagement.js";
import OrbitAiAdmin from "./pages/admin/OrbitAiAdmin.js";
import OrbitMetadataManagement from "./pages/admin/OrbitMetadataManagement.js";
import ContentReview from "./pages/admin/ContentReview.js";
import PlanCentral from "./pages/admin/PlanCentral.js";
import PlanCentralDocs from "./pages/admin/PlanCentralDocs.js";
import ClientReportsManagement from "./pages/admin/ClientReportsManagement.js";
import { HotKeysProvider } from "./providers/HotKeysProvider.js";
import OtherPlanTools from "./pages/plan/OtherPlanTools.js";
import EmailClientUsers from "./pages/admin/EmailClientUsers.js";
import IdleTimer from './components/IdleTimer';
import { SurveyProvider, useSurvey } from './SurveyContext';
import SurveyModal from './components/SurveyModal';
import ClientDashboardEntryRoute from "./pages/dashboards/ClientDashboardEntryRoute";
import DashboardHomeEntryRoute from "./pages/dashboards/DashboardHomeEntryRoute";
import CrossClientDashboardV3 from "./pages/dashboards/v3/CrossClientDashboardV3";
import Reports from "./pages/dashboards/Reports";
import CreateCustomReport from "./pages/client/CreateCustomReport";
import EditCustomReport from "./pages/client/EditCustomReport";
import ClientDashboardV3Home from "./pages/dashboards/v3/ClientDashboardV3Home";
import ClientDashboardV3IndieAi from "./pages/dashboards/v3/ClientDashboardV3IndieAi";
import ClientDashboardV3Performance from "./pages/dashboards/v3/ClientDashboardV3Performance";
import ClientDashboardV3Meetings from "./pages/dashboards/v3/ClientDashboardV3Meetings";
import ClientDashboardV3Reports from "./pages/dashboards/v3/ClientDashboardV3ReportsBridge";
import V3CustomCalendarManagementPage from "./pages/v3/admin/V3CustomCalendarManagementPage";
import V3ClientNotificationsManagementPage from "./pages/v3/admin/V3ClientNotificationsManagementPage";
import V3M1AdvisorsManagementPage from "./pages/v3/admin/V3M1AdvisorsManagementPage";
import V3DevToolsPage from "./pages/v3/admin/V3DevToolsPage";
import V3FlightControlPage from "./pages/v3/admin/V3FlightControlPage";
import V3OrbitMetadataManagementPage from "./pages/v3/admin/V3OrbitMetadataManagementPage";
import V3ContentReviewPage from "./pages/v3/admin/V3ContentReviewPage";
import V3PlanCentralPage from "./pages/v3/admin/V3PlanCentralPage";
import V3PlanCentralDocsPage from "./pages/v3/admin/V3PlanCentralDocsPage";
import V3ClientReportsManagementPage from "./pages/v3/admin/V3ClientReportsManagementPage";
import V3PermissionsPage from "./pages/v3/admin/V3PermissionsPage";
import V3UserDetailPage from "./pages/v3/admin/V3UserDetailPage";
import V3UserRolesPage from "./pages/v3/admin/V3UserRolesPage";
import V3UsersPage from "./pages/v3/admin/V3UsersPage";
import V3ClientAddPage from "./pages/v3/client/V3ClientAddPage";
import V3ClientAnalyticsPage from "./pages/v3/client/V3ClientAnalyticsPage";
import V3ClientCategoriesPage from "./pages/v3/client/V3ClientCategoriesPage";
import V3ClientClassesPage from "./pages/v3/client/V3ClientClassesPage";
import V3ClientLocationsPage from "./pages/v3/client/V3ClientLocationsPage";
import V3ClientMasterClassPage from "./pages/v3/client/V3ClientMasterClassPage";
import V3ClientPlanPreviewPage from "./pages/v3/client/V3ClientPlanPreviewPage";
import V3ClientPosMappingPage from "./pages/v3/client/V3ClientPosMappingPage";
import V3ClientProfilePage from "./pages/v3/client/V3ClientProfilePage";
import V3ClientReportLibraryPage from "./pages/v3/client/V3ClientReportLibraryPage";
import V3ClientSetupPage from "./pages/v3/client/V3ClientSetupPage";
import V3ClientTagsPage from "./pages/v3/client/V3ClientTagsPage";
import V3ImportClassPage from "./pages/v3/client/V3ImportClassPage";
import V3UploadDataPage from "./pages/v3/client/V3UploadDataPage";
import V3CopyPlanFileDetailPage from "./pages/v3/plan/V3CopyPlanFileDetailPage";
import V3CopyPlanLineDetailPage from "./pages/v3/plan/V3CopyPlanLineDetailPage";
import V3CopyPlanPage from "./pages/v3/plan/V3CopyPlanPage";
import V3CopyPlanUploadPage from "./pages/v3/plan/V3CopyPlanUploadPage";
import V3LivePlanModifyPage from "./pages/v3/plan/V3LivePlanModifyPage";
import V3LivePlanModifyWeeklyPage from "./pages/v3/plan/V3LivePlanModifyWeeklyPage";
import V3OtherPlanToolsPage from "./pages/v3/plan/V3OtherPlanToolsPage";

// Integrations
import ShopifyAuthLanding from "./pages/shopify/ShopifyAuthLanding.page";
import { initAmplitudeForCurrentEnv } from './services/amplitudeBootstrap'

// Force pipeline
initAmplitudeForCurrentEnv()

const SURVEY_EXEMPT_ROUTES = [
  '/login',
  '/forgot-password',
  '/restore-password',
  '/shopify-auth-landing',
  '/register',
];

function checkRouteDoesntContainExemptKeyword(pathname) {
  return !SURVEY_EXEMPT_ROUTES.some(exemptRoute => pathname.includes(exemptRoute));
}

function AuthenticatedRouteShell() {
  return <>
    <IdleTimer />
    <Outlet />
  </>
}

/**
 * The main component of the application.
 * @returns {JSX.Element} The rendered App component.
 */
function App() {

  return (
      <SurveyProvider>
        <AppContent />
      </SurveyProvider>
  );
}
/**
 * The main component of the application.
 * @returns {JSX.Element} The rendered App component.
 */
function AppContent() {
  const location = useLocation();
  const { surveyCompleted } = useSurvey();

  return (
    <ThemeProvider theme={theme}>
      <AuthContext.Provider>
      <ConfirmDialogProvider>
      <GlobalTip.Provider>
      <HotKeysProvider>
      <CurrentClientContext.Provider>
        <Routes>
          <Route path="/shopify-auth-landing" element={<ShopifyAuthLanding />} />
          <Route element={<Layout />} >
            <Route path="/login" element={<NotLogin />}/>
            <Route path="/forgot-password" element={<ForgotPassword />}/>
            <Route path="/restore-password/:code" element={<RestorePassword />}/>
          </Route>
                  <Route element={<AuthMiddleware />}>
                    <Route element={<AuthenticatedRouteShell />}>
                      <Route element={<MainLayout />} >

                      <Route path="/" element={<DashboardHomeEntryRoute mode="home" />} />
                      <Route path="/cross-client-dashboard" element={<DashboardHomeEntryRoute mode="cross-client" />} />
                      <Route path="/users" element={<Users />} />
                      <Route path="/users/:user_id" element={<UserDetail />} />
                      <Route path="/admin/user-roles" element={<UserRoles />} />
                      <Route path="/admin/permissions" element={<Permission />} />
                      <Route path="/admin/flightcontrol" element={<FlightControl />} />
                      {/* The permissions check for role-create maybe should be replaced with a role based check for admin/support */}
                      <Route element={<PermissionMiddleware permissions={['role-create']} />}>
                        <Route path="/plan/copy" element={<CopyPlan />} />
                        <Route path="/plan/copy/upload" element={<CopyPlanUpload />} />
                        <Route path="/plan/copy/file/:id" element={<CopyPlanFileDetail />} />
                        <Route path="/plan/copy/line/:id" element={<CopyPlanFileDetail mode="line" />} />
                        <Route path="/admin/custom-calendar-management" element={<CustomCalendarManagement />} />
                        <Route path="/admin/orbit-ai" element={<Navigate to="/admin/orbit-ai/forecast-runs" replace />} />
                        <Route path="/admin/orbit-ai/forecast-runs" element={<OrbitAiAdmin />} />
                        <Route path="/admin/orbit-ai/forecast-runs/:triggerRequestId" element={<OrbitAiAdmin />} />
                        <Route path="/admin/orbit-ai/token-usage" element={<OrbitAiAdmin />} />
                        <Route path="/admin/orbit-ai/token-usage/drilldown" element={<OrbitAiAdmin />} />
                        <Route path="/admin/orbit-ai/maintenance" element={<OrbitAiAdmin />} />
                        <Route path="/admin/orbit-metadata" element={<OrbitMetadataManagement />} />
                        <Route path="/admin/content-review" element={<ContentReview />} />
                        <Route path="/admin/plan-central" element={<PlanCentral />} />
                        <Route path="/admin/plan-central/docs" element={<PlanCentralDocs />} />
                        <Route path="/admin/client-reports" element={<ClientReportsManagement />} />
                      </Route>
                      <Route element={<PermissionMiddleware permissions={['add-client']} />}>
                        <Route path="/client/setup" element={<ClientSetup />} />
                        <Route path="/client/add" element={<ClientAdd />} />
                      </Route>
                      <Route element={<PermissionMiddleware permissions={['view-client-info']} />}>
                        <Route path="/clients/lightspeed-auth-landing" element={<LightspeedAuthLanding />} />
                      </Route>
                      <Route element={<ClientMiddleware />}>
                        <Route element={<PermissionMiddleware permissions={['add-client']} />}>
                          <Route path="/client/:client_code/setup" element={<ClientSetup />} />
                        </Route>
                        <Route path="/client/:client_code/simple-dashboard" element={<ClientDashboardEntryRoute />} />
                        <Route path="/clients/:client_code/planninig/:clientId/preview" element={<ClientPlanPreview />} />
                        <Route path="/clients/:client_code/kpi/:clientId" element={<ClientKPI />} />
                        <Route path="/clients/:client_code/analytics/:clientId" element={<ClientAnalytics />} />
                        <Route path="/clients/:client_code/reports-lib/:clientId" element={<Reports />} />
                        <Route path="/clients/:client_code/reports-lib/:clientId/create" element={<CreateCustomReport />} />
                        <Route path="/clients/:client_code/reports-lib/:clientId/edit/:filterId" element={<EditCustomReport />} />
                        {process.env.REACT_APP_REPORT_LOCKOUT_CURRENT_MONTH ?
                            <Route element={<PermissionMiddleware permissions={['role-create']} />}> {/* Temporary lockout from report for all non admin users when lockout env true */}
                              <Route path="/clients/:client_code/report-library/:clientId" element={<ClientReportLibrary />} />
                            </Route>
                            : <Route path="/clients/:client_code/report-library/:clientId" element={<ClientReportLibrary />} />}
                        <Route path="/clients/:client_code/upload-data" element={<UploadData />} />
                        <Route path="/clients/:client_code/profile" element={<ClientProfile />} />
                        <Route element={<PermissionMiddleware permissions={['full-planning']} />}>
                          <Route path="/clients/:client_code/plan/locationclasses/:location_class_id" element={<BasePlan />} />
                          <Route path="/clients/:client_code/plan-future-base/locationclasses/:location_class_id" element={<BasePlan type='future' />} />
                          <Route path="/clients/:client_code/live-plan-edit" element={<LivePlanModify />} />
                          <Route path="/clients/:client_code/live-plan-edit-weekly" element={<LivePlanModifyWeekly />} />
                          <Route path="/clients/:client_code/plan/other-tools" element={<OtherPlanTools />} />
                          <Route path="/clients/:client_code/email-client-users" element={<EmailClientUsers />} />
                        </Route>
                        <Route element={<PermissionMiddleware permissions={['view-client-info']} />}>
                          <Route path="/clients/:client_code/locations" element={<ClientLocations />} />
                          <Route path="/clients/:client_code/classes" element={<ClientClasses />} />
                          <Route path="/clients/:client_code/categories" element={<ClientCategories />} />
                          <Route path="/clients/:client_code/indie-ai" element={<IndieAi />} />
                          <Route path="/clients/:client_code/import-class" element={<ImportClass />} />
                          <Route path="/clients/:client_code/pos-mapping" element={<ClientPosMapping />} />
                        </Route>
                        <Route element={<PermissionMiddleware permissions={['full-planning']} />}>
                          <Route path="/clients/:client_code/tags" element={<ClientTags />} />
                          <Route path="/clients/:client_code/master-class" element={<ClientMasterClassSetting />} />
                          {/* <Route path="/clients/:client_code/sync" element={<ClientSync />} /> */}
                        </Route>
                      </Route>
                      <Route element={<PermissionMiddleware permissions={['dev-tools']} />}>
                        <Route path="/dev-tools" element={<DevTools />} />
                      </Route>
                      </Route>
                    <Route element={<V3GlobalLayout />}>
                      <Route path="/v3/home" element={<Home visualVariant="v3" />} />
                      <Route path="/v3/cross-client-dashboard" element={<CrossClientDashboardV3 />} />
                      <Route path="/v3/users" element={<V3UsersPage />} />
                      <Route path="/v3/users/:user_id" element={<V3UserDetailPage />} />
                      <Route path="/v3/admin/user-roles" element={<V3UserRolesPage />} />
                      <Route path="/v3/admin/permissions" element={<V3PermissionsPage />} />
                      <Route element={<PermissionMiddleware permissions={['role-create']} />}>
                        <Route path="/v3/plan/copy" element={<V3CopyPlanPage />} />
                        <Route path="/v3/plan/copy/upload" element={<V3CopyPlanUploadPage />} />
                        <Route path="/v3/plan/copy/file/:id" element={<V3CopyPlanFileDetailPage />} />
                        <Route path="/v3/plan/copy/line/:id" element={<V3CopyPlanLineDetailPage />} />
                        <Route path="/v3/admin/custom-calendar-management" element={<V3CustomCalendarManagementPage />} />
                        <Route path="/v3/admin/client-notifications" element={<V3ClientNotificationsManagementPage />} />
                        <Route path="/v3/admin/m1-advisors" element={<V3M1AdvisorsManagementPage />} />
                        <Route path="/v3/admin/orbit-ai" element={<Navigate to="/v3/admin/orbit-ai/forecast-runs" replace />} />
                        <Route path="/v3/admin/orbit-ai/forecast-runs" element={<OrbitAiAdmin />} />
                        <Route path="/v3/admin/orbit-ai/forecast-runs/:triggerRequestId" element={<OrbitAiAdmin />} />
                        <Route path="/v3/admin/orbit-ai/token-usage" element={<OrbitAiAdmin />} />
                        <Route path="/v3/admin/orbit-ai/token-usage/drilldown" element={<OrbitAiAdmin />} />
                        <Route path="/v3/admin/orbit-ai/maintenance" element={<OrbitAiAdmin />} />
                        <Route path="/v3/admin/orbit-metadata" element={<V3OrbitMetadataManagementPage />} />
                        <Route path="/v3/admin/content-review" element={<V3ContentReviewPage />} />
                        <Route path="/v3/admin/plan-central" element={<V3PlanCentralPage />} />
                        <Route path="/v3/admin/plan-central/docs" element={<V3PlanCentralDocsPage />} />
                        <Route path="/v3/admin/client-reports" element={<V3ClientReportsManagementPage />} />
                      </Route>
                      <Route element={<PermissionMiddleware permissions={['add-client']} />}>
                        <Route path="/v3/client/add" element={<V3ClientAddPage />} />
                      </Route>
                      <Route element={<PermissionMiddleware permissions={['dev-tools']} />}>
                        <Route path="/v3/dev-tools" element={<V3DevToolsPage />} />
                      </Route>
                      <Route path="/v3/admin/flightcontrol" element={<V3FlightControlPage />} />
                    </Route>
                    <Route element={<ClientMiddleware />}>
                      <Route element={<V3SiteLayout />}>
                        <Route element={<PermissionMiddleware permissions={['add-client']} />}>
                          <Route path="/v3/client/:client_code/setup" element={<V3ClientSetupPage />} />
                        </Route>
                        <Route path="/v3/client/:client_code/planninig/:clientId/preview" element={<V3ClientPlanPreviewPage />} />
                        <Route path="/v3/client/:client_code/analytics/:clientId" element={<V3ClientAnalyticsPage />} />
                        {process.env.REACT_APP_REPORT_LOCKOUT_CURRENT_MONTH
                          ? <Route element={<PermissionMiddleware permissions={['role-create']} />}>
                              <Route path="/v3/client/:client_code/report-library/:clientId" element={<V3ClientReportLibraryPage />} />
                            </Route>
                          : <Route path="/v3/client/:client_code/report-library/:clientId" element={<V3ClientReportLibraryPage />} />}
                        <Route path="/v3/client/:client_code/upload-data" element={<V3UploadDataPage />} />
                        <Route path="/v3/client/:client_code/profile" element={<V3ClientProfilePage />} />
                        <Route element={<PermissionMiddleware permissions={['full-planning']} />}>
                          <Route path="/v3/client/:client_code/live-plan-edit" element={<V3LivePlanModifyPage />} />
                          <Route path="/v3/client/:client_code/live-plan-edit-weekly" element={<V3LivePlanModifyWeeklyPage />} />
                          <Route path="/v3/client/:client_code/plan/other-tools" element={<V3OtherPlanToolsPage />} />
                        </Route>
                        <Route element={<PermissionMiddleware permissions={['view-client-info']} />}>
                          <Route path="/v3/client/:client_code/locations" element={<V3ClientLocationsPage />} />
                          <Route path="/v3/client/:client_code/classes" element={<V3ClientClassesPage />} />
                          <Route path="/v3/client/:client_code/categories" element={<V3ClientCategoriesPage />} />
                          <Route path="/v3/client/:client_code/import-class" element={<V3ImportClassPage />} />
                          <Route path="/v3/client/:client_code/pos-mapping" element={<V3ClientPosMappingPage />} />
                        </Route>
                        <Route element={<PermissionMiddleware permissions={['full-planning']} />}>
                          <Route path="/v3/client/:client_code/tags" element={<V3ClientTagsPage />} />
                          <Route path="/v3/client/:client_code/master-class" element={<V3ClientMasterClassPage />} />
                        </Route>
                        <Route path="/v3/client/:client_code/indie-ai" element={<ClientDashboardV3IndieAi />} />
                        <Route path="/v3/client/:client_code/simple-dashboard" element={<ClientDashboardV3Home />} />
                        <Route path="/v3/client/:client_code/simple-dashboard/performance" element={<ClientDashboardV3Performance />} />
                        <Route path="/v3/client/:client_code/simple-dashboard/meetings" element={<ClientDashboardV3Meetings />} />
                        <Route path="/v3/client/:client_code/simple-dashboard/reports/:clientId" element={<ClientDashboardV3Reports />} />
                        <Route path="/v3/client/:client_code/simple-dashboard/reports/:clientId/create" element={<CreateCustomReport />} />
                        <Route path="/v3/client/:client_code/simple-dashboard/reports/:clientId/edit/:filterId" element={<EditCustomReport />} />
                      </Route>
                    </Route>
                    </Route>
                  </Route>
                  <Route path="*" element={<NotFound />} />
                </Routes>
                {checkRouteDoesntContainExemptKeyword(location.pathname)
                  && !surveyCompleted 
                  && <SurveyModal />
                }
              </CurrentClientContext.Provider>
            </HotKeysProvider>
          </GlobalTip.Provider>
        </ConfirmDialogProvider>
      </AuthContext.Provider>
    </ThemeProvider>
  );
}

export default App
